export const COMMISSION_TYPE = {
  NO_COMMISSION: {
    id: "NO_COMMISSION",
    translationId: "bez provize",
    queryValue: "offersSorting.latest",
  },
  COMMISSION: {
    id: "COMMISSION",
    translationId: "s provizí",
    queryValue: "offersSorting.best",
  },
};
